var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"financialclose-home-view"}},[_c('lb-datatableaction',{attrs:{"headers":_vm.tableHeaders,"tabledata":_vm.taskid,"selectfilter":_vm.selectfilter,"page_details":_vm.page_details,"data-testid":"financialclose-home-view-datatable"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }